export default {
  inheritAttrs: false,
  name: "WPageIframe",
  __WF_: true,
  props: ["src", "ownStyle"],
  data() {
    return {};
  },
  render() {
    function setIframeHeight(e) {
      let iframe = document.getElementById('page-frame');
      if (iframe) {
        var iframeWin =
          iframe.contentWindow || iframe.contentDocument.parentWindow;
        if (iframeWin.document.body) {
          iframe.height =
            iframeWin.document.documentElement.scrollHeight ||
            iframeWin.document.body.scrollHeight;
        }

        let title = iframe.contentWindow.document.title;
        window.top.document.title = title || '';
      }
    }

    let c_width = document.body.clientWidth; // 屏幕宽度
    let iframeStyle = 'width: 100%;';
    if (c_width > 800) {
      iframeStyle = 'width: 630px; margin: 0 auto;position: absolute; left: 50%; margin-left: -315px;'
    }

    iframeStyle += this.ownStyle;

    const iframeProps = {
      on: {
        load: setIframeHeight
      },
      attrs: {
        src: this.src,
        style: iframeStyle
      }
    }

    return (
      <div>
        <iframe
        {...iframeProps}
        id="page-frame"
        frameborder="0"
      />
      </div>
    );
  }
};
